<template>
  <div>
    <slot />
  </div>
</template>

<script>
const defaultLayout = "LayoutDefault";
export default {
  name: "LayoutAuth",
  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;
      return () => import(`@/layouts/${layout}.vue`);
    },
  },
};
</script>
